import React from "react";
import { Link } from "react-router-dom";
import { BoxAnalyticCharArea } from "../../components/Analytic/BoxAnalyticCharArea";
import { BoxAnalyticCharBar } from "../../components/Analytic/BoxAnalyticCharBar";
import { BoxAnalyticCount } from "../../components/Analytic/BoxAnalyticCount";
import { Box } from "../../components/Box";
import { TableClean } from "../../components/TableClean";
import { useBilletsCountClient } from "../../hook/queries/useBillet";
import { useDevolutionsCountClient } from "../../hook/queries/useDevolution";
import {
  statusColorAnalytic,
  useOrderAnalytic,
} from "../../hook/queries/useOrderAnalytic";
import { ContainerBoxAnalytic } from "../analytic/styles";

interface HomeAnalyticProps {
  userType: "admin" | "client" | "seller" | "sellerManager";
  clientId?: number;
  userPermission?: string;
}

export const HomeAnalytic = ({ userType, clientId }: HomeAnalyticProps) => {
  const totalBilletClient = useBilletsCountClient(clientId);
  const totalDevolutionClient = useDevolutionsCountClient(clientId, {
    pendencyType: 1,
  });
  const orderAnalytic = useOrderAnalytic({
    seller: ["seller", "sellerManager"].includes(userType),
    client: userType === "client",
  });

  if (["admin"].includes(userType)) return null;

  return (
    <>
      {["client"].includes(userType) && (
        <ContainerBoxAnalytic style={{ marginTop: 24, marginBottom: 0 }}>
          <BoxAnalyticCount
            description="Devoluções Pendentes"
            qtd={totalDevolutionClient.data?.totalCount ?? 0}
            isLoading={totalDevolutionClient.isLoading}
            externalLink={`/devolucoes`}
          />

          <BoxAnalyticCount
            description="Boletos em Aberto"
            qtd={totalBilletClient.data?.totalCount ?? 0}
            isLoading={totalBilletClient.isLoading}
            externalLink="/boletos"
            obs="Boletos em aberto referente á 15 dias antecedente ao dia de hoje."
          />
        </ContainerBoxAnalytic>
      )}

      {["seller", "client", "sellerManager"].includes(userType) && (
        <ContainerBoxAnalytic style={{ marginTop: 9 }}>
          <BoxAnalyticCharBar
            title="Pedidos por Situação"
            descriptions={orderAnalytic?.data?.totalAmount.description ?? []}
            values={orderAnalytic?.data?.totalAmount.amount ?? []}
            colors={orderAnalytic?.data?.totalAmount.description.map((s) => {
              return statusColorAnalytic.find((f) => f.name === s)?.color ?? "";
            })}
            obs={
              ["seller", "sellerManager"].includes(userType) ? (
                <span className="span-alert">
                  *Pedidos{" "}
                  <Link
                    to={"/representante/pedidosV2/?page=1&status=Em+análise"}
                    style={{
                      color: "rgb(151, 0, 194)",
                    }}
                  >
                    EM ANÁLISE
                  </Link>{" "}
                  são cancelados em ate 4 dias.
                </span>
              ) : undefined
            }
          />

          <BoxAnalyticCharArea
            title="Valores dos pedidos"
            dates={orderAnalytic?.data?.totalPriceMonths.date ?? []}
            values={orderAnalytic?.data?.totalPriceMonths.content ?? []}
            colors={orderAnalytic?.data?.totalPriceMonths.content.map((s) => {
              return (
                statusColorAnalytic.find((f) => f.name === s.name)?.color ?? ""
              );
            })}
            obs={
              <>
                *Este faturamento é bruto e não corresponde ao cálculo de
                comissões.
              </>
            }
          />

          {["seller", "sellerManager"].includes(userType) &&
            !!orderAnalytic?.data?.totalConcepts.length && (
              <Box>
                <h3>Clientes com oportunidade de regularização</h3>

                <div style={{ width: "100%", marginTop: "1rem" }}>
                  <TableClean
                    data={
                      orderAnalytic?.data?.totalConcepts.map((item) => ({
                        description: item.description,
                        amount: item.amount.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }),
                      })) ?? []
                    }
                    columns={[
                      { title: "SCORE", field: "description" },
                      { title: "VALOR", field: "amount" },
                    ]}
                  />

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="span-alert">
                      *Acessar cliente com{" "}
                      <Link
                        to={
                          "/representante/pedidosV2?tab=Oportunidade%20de%20regulariza%C3%A7%C3%A3o"
                        }
                        style={{
                          color: "rgb(151, 0, 194)",
                        }}
                      >
                        OPORTUNIDADE DE REGULARIZAÇÃO
                      </Link>{" "}
                    </span>

                    <span className="span-alert">
                      Obs: esta consulta considera pedidos com data de
                      faturamento até o último dia do próximo mês
                    </span>
                  </div>
                </div>
              </Box>
            )}
        </ContainerBoxAnalytic>
      )}
    </>
  );
};
